<ng-container>
  <udex-message-strip
    *ngIf="showMessage && isMouseOverSelectDifferentShipToFeatureToggleEnabled"
    class="body--s udex-mb-20"
    design="Information"
    status-type="Icon"
    hide-close-button
  >
    {{ 'checkout.digitalNativeCheckout.shipToAddressMessage' | cxTranslate }}
  </udex-message-strip>
  <div class="udex-mb-4">
    <dcp-address-data [address]="companyAddress" [header]="detailsTitle">
      <div class="d-flex align-items-center">
        <udex-checkbox
          *ngIf="isCreateNewLocationFeatureToggleEnabled || shipToAddresses.length"
          data-cy="add-ship-to-address"
          [text]="'checkout.digitalNativeCheckout.shipToAddress' | cxTranslate"
          [checked]="isShipToCheckboxChecked"
          (change)="onChange($event)"
          (keydown.enter)="onKeyDown()"
          wrapping-type="Normal"
        ></udex-checkbox>
        <dcp-icon-button-tooltip
          data-cy="add-access-location-tooltip"
          [openOnClick]="true"
          *ngIf="isCreateNewLocationFeatureToggleEnabled || shipToAddresses.length"
          accessibleName="addShipToLocationTooltip"
        >
          <div class="body--s text-grey add-access-location-tooltip">
            {{ 'checkout.digitalNativeCheckout.addDifferentAccessLocationTooltip' | cxTranslate }}
          </div>
        </dcp-icon-button-tooltip>
      </div>
      <ng-container *ngIf="isShipToCheckboxChecked">
        <div class="mt-4">
          <dcp-company-addresses
            (selectedAddress)="onAddressSelect($event)"
            [addresses]="shipToAddresses"
            [initialSelectedShipToAddress]="initialSelectedShipToAddress"
            [header]="shipToTitle"
            [addAddressModalLinkText]="'checkout.digitalNativeCheckout.createNewLocation' | cxTranslate"
            [addAddressModalHeaderText]="'checkout.digitalNativeCheckout.newPrimaryAccessLocation.heading' | cxTranslate"
            [addAddressModalCreateButtonText]="'checkout.digitalNativeCheckout.newPrimaryAccessLocation.submit' | cxTranslate"
            [showEditButton]="true"
            [editAddressModalHeaderText]="'checkout.digitalNativeCheckout.editAddress.header' | cxTranslate"
            [editAddressModalSubmitButtonText]="'checkout.digitalNativeCheckout.editAddress.submitButton' | cxTranslate"
            [addAddressModalUsageType]="usageType"
          >
          </dcp-company-addresses>
        </div>
      </ng-container>
    </dcp-address-data>
  </div>
</ng-container>
